import * as React from 'react';
import { TFooter } from './Footer.types';
import { Facebook, Instagram, LinkedIn, Twitter } from '@mui/icons-material';
import './Footer.styled.scss';

export const Footer: TFooter = () => (
  <footer className="footer">
    <div className="footer__container">
      <div className="footer__section footer__section--about">
        <h3 className="footer__title">About Us</h3>
        <p className="footer__text">
          We offer a variety of online courses to help you master new skills and
          enhance your career.
        </p>
      </div>

      <div className="footer__section footer__section--links">
        <h3 className="footer__title">Quick Links</h3>
        <ul className="footer__links">
          <li className="footer__link">
            <a href="#courses" className="footer__link-item">
              Courses
            </a>
          </li>
          <li className="footer__link">
            <a href="#about" className="footer__link-item">
              About Us
            </a>
          </li>
          <li className="footer__link">
            <a href="#contact" className="footer__link-item">
              Contact
            </a>
          </li>
          <li className="footer__link">
            <a href="#support" className="footer__link-item">
              Support
            </a>
          </li>
        </ul>
      </div>

      <div className="footer__section footer__section--social">
        <h3 className="footer__title">Follow Us</h3>
        <div className="footer__social-icons">
          <a
            href="https://facebook.com"
            className="footer__social-icon"
            aria-label="Facebook"
          >
            <Facebook />
          </a>
          <a
            href="https://instagram.com"
            className="footer__social-icon"
            aria-label="Instagram"
          >
            <Instagram />
          </a>
          <a
            href="https://twitter.com"
            className="footer__social-icon"
            aria-label="Twitter"
          >
            <Twitter />
          </a>
          <a
            href="https://linkedin.com"
            className="footer__social-icon"
            aria-label="LinkedIn"
          >
            <LinkedIn />
          </a>
        </div>
      </div>

      <div className="footer__section footer__section--contact">
        <h3 className="footer__title">Contact</h3>
        <p className="footer__text">
          123 Course St, Learning City, Educationland
        </p>
        <p className="footer__text">
          Email:{' '}
          <a href="mailto:support@courses.com" className="footer__link-item">
            support@courses.com
          </a>
        </p>
        <p className="footer__text">Phone: +1 (800) 123-4567</p>
      </div>
    </div>

    <div className="footer__bottom">
      <p className="footer__bottom-text">
        &copy; 2024 Courses Academy. All Rights Reserved.
      </p>
    </div>
  </footer>
);
